import "./chatadduser.scss";
import CloseIcon from '@mui/icons-material/Close';
import { useChatAddUser } from "./hooks/useChatAddUser";
import { SearchForm } from "./components/SearchForm";
import { UserResultItem } from "./components/UserResultItem";

const Chatadduser = ({ onClose }) => {
    const { users, isLoading, handleSearch, handleAdd } = useChatAddUser(onClose);

    return (
        <div className="addUserOverlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}> 
                <div className="header">
                    <h3>
                        Find Friend
                    </h3>

                    <CloseIcon className="closeIcon" onClick={onClose}/>
                </div>

                <SearchForm 
                    handleSearch={handleSearch} 
                    isLoading={isLoading} 
                />

                <div className="resultsContainer">
                    {users.map((user) => (
                        <UserResultItem 
                            key={user.id || user._id}
                            user={user}
                            onAdd={handleAdd}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Chatadduser;